module.exports = __webpack_public_path__ + "static/play-dark-8c38bd1b3d6166544aecc6741892b60e.png";